import { ActiveDateProvider, AuthenticationGate } from '@goodlok/react-sdk'
import { AdminLayout } from '../components/AdminLayout'

export default function AdminPage() {
	return (
		<ActiveDateProvider>
			<AuthenticationGate allowedRoles={['admin', 'shifts_manager']}>
				<AdminLayout />
			</AuthenticationGate>
		</ActiveDateProvider>
	)
}
